var React = require('react');

function EmergencyPhone (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"0","strokeWidth":"4","strokeLinecap":"round","fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M73.481 27a17.477 17.477 0 00-12.364 5.126A17.495 17.495 0 0056 44.5v.936h0V62h17.509C83.17 62 91 54.165 91 44.5S83.17 27 73.51 27h-.029zM73.5 37v16M65 45.5h16","key":0}),React.createElement("path",{"d":"M75.762 83.257L64.886 72.434c-2.754-2.755-5.95-.132-5.95-.132l-4.869 3.169a1.73 1.73 0 01-2.406-.517L39.31 55.724a1.75 1.75 0 01.526-2.407l4.634-2.98a4.702 4.702 0 002.444-5.577l-5.377-14.575c-1.316-3.545-5.64-1.71-5.64-1.71l-3.938 1.71c-8 3.414-6.909 11.764-6.909 11.764s1.231 36.343 35.898 52.394c0 0 5.508 2.755 12.07-3.018l2.424-2.295s3.281-2.887.32-5.773zM42 51l-8-22M57 74l17 17","key":1})]));
}

EmergencyPhone.defaultProps = {"width":"114","height":"114"};

module.exports = EmergencyPhone;

EmergencyPhone.default = EmergencyPhone;
